import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const HasSpa = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.916 8.02484C12.7577 5.69984 11.816 3.43317 10.0493 1.6665C8.34046 3.36899 7.28948 5.6215 7.08268 8.02484C8.15768 8.5915 9.14101 9.32484 9.99935 10.2165C10.8526 9.33977 11.8365 8.60045 12.916 8.02484ZM9.99935 12.8748C8.20768 10.1415 5.14935 8.33317 1.66602 8.33317C1.66602 16.6665 9.43268 18.2415 9.99935 18.3332C10.566 18.2332 18.3327 16.6665 18.3327 8.33317C14.8493 8.33317 11.791 10.1415 9.99935 12.8748Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default HasSpa;
